// extracted by mini-css-extract-plugin
export default {"container":"container-a2abP1wb","image":"image-yFCIAF3L","count":"count-bT05zDOk","countSm":"countSm-WWtMD35R","bold":"bold-MfQQ0U4D"};